
import { mapActions, mapState } from 'vuex'
import { mdiClockStart } from '@mdi/js'
import AppBar from './app-bar'
import Cm24Footer from './cm24-footer'
import Notifications from '@/components/tools/notifications'

import Cm24Snackbar from '@/components/ui/Cm24Snackbar'

import MerchantPopups from '@/components/merchant/MerchantPopups.vue'
import Cm24SystemBar from '@/components/ui/Cm24SystemBar.vue'
import tracking from '@/components/tools/tracking'
import AvailabilityConfirmationModal from '@/components/account/vehicles/AvailabilityConfirmationModal.vue'

export default {
  name: 'Default',
  components: {
    AvailabilityConfirmationModal,
    Cm24SystemBar,
    Cm24Snackbar,
    Notifications,
    AppBar,
    Cm24Footer,
    MerchantPopups
  },

  data () {
    return {
      mdiClockStart,
      title: 'caravanmarkt24'
    }
  },
  async fetch () {
    if (this.loggedIn) {
      try {
        await Promise.all([
          this.getCustomer(),
          this.getCustomerAttributes()
        ])

        const languageSetting = this.customer?.languageSetting
        if (languageSetting) {
          this.$i18n.setLocale(languageSetting)
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      htmlAttrs: { ...i18nHead.htmlAttrs },
      title: this.$t('pageTitle'),
      meta: [
        { charset: 'utf-8' },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1'
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('description')
        },
        {
          name: 'facebook-domain-verification',
          content: '5v6mhgrebcbxn70oj2o60idnosfeal'
        },
        ...i18nHead.meta
      ],
      script: [
        {
          hid: 'poptin-spa',
          type: 'text/javascript',
          innerHTML: 'var poptin_single_page_app = true;'
        },
        {
          src: 'https://sak.userreport.com/caravanmarkt24/launcher.js',
          async: true,
          id: 'userreport-launcher-script'
        }

      ],
      __dangerouslyDisableSanitizersByTagID: { 'poptin-spa': ['innerHTML'] },
      link: [
        {
          rel: 'preconnect',
          href: 'https://fonts.googleapis.com'
        },
        {
          rel: 'preload',
          as: 'style',
          href: 'https://fonts.googleapis.com/css2?family=Heebo:wght@100;200;300;400;600;700;800;900&display=swap'
        },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Heebo:wght@100;200;300;400;600;700;800;900&display=swap'
        },
        {
          rel: 'preconnect',
          href: 'https://mtr.caravanmarkt24.de'
        },
        {
          rel: 'preconnect',
          href: 'https://www.googletagmanager.com'
        },
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: '/favicon.svg'
        },
        {
          rel: 'alternate icon',
          type: 'image/x-icon',
          href: '/favicon.ico'
        },
        ...i18nHead.link
      ]
    }
  },
  computed: {
    loggedIn () {
      return this.$auth.loggedIn
    },

    ...mapState('customer', {
      customer: state => state.customer,
      customerAddress: state => state.customerAddress,
      merchant: state => state.merchant,
      merchantAddress: state => state.merchantAddress,
      customerId: state => state.customer?.customerId,
      emailVerified: state => state.customer?.emailVerified,
      merchantId: state => state.merchant?.merchantId,
      privateProfileCompleted: state => state.customer?.privateProfileCompleted,
      commercialProfileCompleted: state => state.customer?.commercialProfileCompleted,
      merchantProfileCompleted: state => state.customer?.merchantProfileCompleted,
      merchantBlocked: state => state.customer?.merchantBlocked,
      profileType: state => state.profileType,

      isMerchant: state => state.merchant?.merchantId !== null
    }),

    appBarColor () {
      if (
        this.$store?.state?.auth?.user &&
        this.$store?.state?.auth?.user['http://cm24.de/roles'] &&
        this.$store?.state?.auth?.user['http://cm24.de/roles'].includes('admin')) {
        return 'secondary'
      } else {
        return 'white'
      }
    },

    showMobileTasksAppBar () {
      return this.$route.name?.startsWith('account-messages')
    }
  },

  async mounted () {
    try {
      this.reuseAuthCookies()
    } catch (e) {
      console.error(e)
    }

    try {
      await this.getAndSetDifferenceToServerTime()
    } catch (e) {
      // console.error(e)
    }

    try {
      if (this.$route.query.mc === 'thai8Iezimie' || this.merchantId) {
        await this.getMerchantCookie(this.$route.query.mc)
      }
    } catch (e) {
      // console.error(e)
    }

    try {
      this.$nextTick(async () => {
        if (this.loggedIn) {
          if (this.emailVerified === false && this.$auth.user?.email_verified === true) {
            if (this.merchantId) {
              const { data } = await this.$axios.put('/private/merchant/check-email-verified', {})
              if (data === 'MERCHANT_COMPLETE_AND_EMAIL_VERIFIED') {
                await this.getCustomer()
              }
            } else if (this.profileType === 'COMMERCIAL') {
              const { data } = await this.$axios.put('/private/customer/commercial/check-email-verified', {})
              if (data === 'COMMERCIAL_COMPLETE_AND_EMAIL_VERIFIED') {
                await this.getCustomer()
              }
            } else {
              const { data } = await this.$axios.put('/private/customer/check-email-verified', {})
              if (data === 'PRIVATE_COMPLETE_AND_EMAIL_VERIFIED') {
                await this.getCustomer()
              }
            }
          }

          if (this.profileType === 'COMMERCIAL' && !this.commercialProfileCompleted) {
            const { data } = await this.$axios.put('/private/customer/commercial/ack-if-account-complete', {})
            if (data === 'COMMERCIAL_COMPLETE_AND_EMAIL_VERIFIED') {
              await this.getCustomer()
            }
          } else if (this.profileType === 'MERCHANT' && !this.merchantProfileCompleted) {
            const { data } = await this.$axios.put('/private/merchant/ack-if-account-complete', {})
            if (data === 'MERCHANT_COMPLETE_AND_EMAIL_VERIFIED') {
              await this.getCustomer()
            }
          } else if (this.profileType === 'PRIVATE' && !this.privateProfileCompleted) {
            const { data } = await this.$axios.put('/private/customer/ack-if-account-complete', {})
            if (data === 'PRIVATE_COMPLETE_AND_EMAIL_VERIFIED') {
              await this.getCustomer()
            }
          }

          if (this.merchantId) {
            try {
              this.$gtm.push({
                event: 'set_merchant_id',
                merchantId: this.merchantId
              })
            } catch (e) {
              console.error(e)
            }
          }
        }

        try {
          const {
            customer,
            merchant,
            customerAddress,
            merchantAddress
          } = this.$store.state.customer
          const customerData = tracking.getUserData(customer, merchant, customerAddress, merchantAddress)
          this.$gtm.init(customerData)

          this.$tapfiliate.init(this)
        } catch (e) {
          console.error(e)
        }
      })
    } catch (e) {
      console.error(e)
    }

    try {
      const url = new URL(location.href)
      url.searchParams.delete('cm24')
      history.replaceState(null, '', url)
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    ...mapActions('customer', ['getCustomer', 'getMerchantCookie', 'getCustomerAttributes']),
    ...mapActions('general', ['getAndSetDifferenceToServerTime']),

    reuseAuthCookies () {
      const accessToken = this.$cookies.get('auth._token.auth0')
      const refreshToken = this.$cookies.get('auth._refresh_token.auth0')

      if (accessToken && refreshToken && this.$auth?.loggedIn === false) {
        console.log('Reusing auth cookies ...', accessToken, refreshToken)
        this.$cookies.set('auth._token.local', accessToken)
        this.$cookies.set('auth._refresh_token.local', refreshToken)

        this.$cookies.remove('auth._token.auth0')
        this.$cookies.remove('auth._refresh_token.auth0')
        window.location.reload()
      }
    }

  }
}
